<template>
    <div>
        <div class="item_quesion">
            <div class="content_question row">
                <div class="item_answer">
                    <component v-model="text" :is="dynamicComponent" />
                    <!-- <div class="text_answer" v-html="parseContent(content.content)"> -->
                        <!-- John likes <input v-model="message" > football. -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        content: String
    },
    created() {
        // console.log(this.content.answers[0])
    },
    methods: {
        parseContent(content) {

            const regex = /\$\$/gi
            let result
            const indices = [];
            while ((result = regex.exec(content))) {
                indices.push(result.index);
            }
            for (let index = indices.length - 1; index >= 0; index--) {
                content = `${content.substr(0, indices[index])}<b-form-input class="input-custom" type="text" @keyup="inputChange($event)" @keydown="inputKeyDown($event)" v-model="answer" autocomplete="false" ref="answer_input_${index}" />${content.substr(indices[index] + 2, content.length)}`
            }

            return content
        },
    },
    computed: {
        dynamicComponent: function() {
            return {
                template: `<div class="text_answer text-start">${this.parseContent(this.content)}</div>`,
                methods: {
                    inputKeyDown(event) {
                        // document.querySelector('input#inputfocus').focus()
                        event.target.focus();
                        event.target.value = this.convertToSlug(event.target.value)
                    },
                    inputChange() {
                        this.$emit('input', this.answer)
                        // console.log(index, id, this.asnwer)
                        // console.log(index, id)
                        // this.$store.commit('SET_ANSWER', {
                        //     id: id,
                        //     value: this.answer
                        // })
                    },
                },
                data() {
                    return {
                        answer: ''
                    }
                },
                mounted() {
                    // let indexOfItem = 0;
                    // const self = this
                    // Object.keys(self.$refs).forEach(()=> {
                    //     self.$set(self.answer, indexOfItem, '')
                    //     self.answer[indexOfItem] = self.$refs['answer_input_'+indexOfItem].getAttribute('data')
                    //     indexOfItem++
                    // })
                },
            }
        }
    },
    watch: {
        text () {
            this.$emit('input', this.text)
        }
    },
    data() {
        return{
            text: '',
        }
    }
}
</script>
<style scoped>
    .header_question h2{
        font-size: 25px;
        font-weight: 800;
        color: #0057a7;
    }
    .content_question{
        /* margin-top: 15px; */
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .text_answer{
        margin-left: 10px;
    }
    .text_answer input{
        border: 1px solid #0057a7;
        border-radius: 12px;
        margin: 0 5px;
        height: 30px;
        padding: 0 10px;
        color: #0057a7;
    }
    @media only screen and (max-width: 768px){
        .header_question h2{
            font-size: 18px;
        }
        .header_question .title_question{
            /* font-size: 17px; */
        }
         .item_answer{
             width: 100% !important;

         }
     }
    
    @media only screen and (max-width: 500px){
        .text_answer input{
            width: 100px;
        }
     }
</style>

<style>
.input-custom {
    display: inline !important;
    width: fit-content !important;
}
</style>